import React from 'react';
import { useState } from 'react';
import { useContext } from "react";
import { useRef } from "react";
import { useNavigate, useParams, useLocation } from 'react-router-dom';

import axios_api from '../../Api';
import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../../Context';
import Loader from '../common/Loader';
import ConfirmationModal from '../common/ConfirmationModal';

import FormHeaderLab from './FormHeaderLab';
import FormHeaderSpecialist from './FormHeaderSpecialist';
import FormRenderer from './FormRenderer';

import { GetTaskStatus } from "../Task"

export default function FormPage ({ formMode, taskUrl }) {

  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [taskParams, setTaskParams] = useState({});
  const [taskData, setTaskData] = useState({});
  const [isDirty, setIsDirty] = useState(false);
  const [errors, setErrors] = useState([]);
  const [assetSet, setAssetSet] = useState([]);
  const [isMaterialsOpen, setIsMaterialsOpen] = useState(false);

  const [uiSchema, setUiSchema] = useState({})
  const [samplesDict, setSamplesDict] = useState({});

  const initialDataRef = useRef({});
  const allowNavigationAfterSubmitRef = useRef(false);
  const [formViewMode, setFormViewMode] = useState();
  const [validationMode, setValidationMode] = useState("ValidateAndHide");

  let { taskId } = useParams();
  taskId = Number(taskId);


  function getLiteral(samplesNumbersLiterals, sampleNumber) {
    //console.log(samplesNumbersLiterals)
    //console.log(sampleNumber)
    for (let n in samplesNumbersLiterals) {
      if (samplesNumbersLiterals[n][0] === sampleNumber) {
        return samplesNumbersLiterals[n][1]
      }
    }
    return undefined
  }

  
  React.useEffect(() => {

    let taskData = axios_api.get(api_url + taskUrl + taskId, {
      headers: {"Authorization": token}
    });
 
    taskData.then(
      (result) => {
        //console.log(result.data)
        //console.log("loading state: " + loading)
        setTaskParams({
          'id': result.data.id,
          'form': result.data.form,
          'deadline_date': result.data.deadline_date,
          'completed_date': result.data.completed_date,
          'samples': result.data.samples.map(
            (sample) => (
              <b key={sample.sample_number_in_from}> {getLiteral(result.data.form.samples_numbers_and_literals, sample.sample_number_in_from)}-{sample.sample.sample_code} </b>
            )
          ),
          'status': result.data.status
        })

        setFormViewMode(result.data.form.form_view_mode);

        let newUiSchema = JSON.parse(JSON.stringify(result.data.form.form_ui_schema))
        setUiSchema(newUiSchema)

        let sDict = {}
        for (let i in result.data.samples) {
          sDict[result.data.samples[i].sample_number_in_from] = result.data.samples[i].sample.sample_code
          setSamplesDict(sDict)
        }

        if (result.data.task_data != null) {
          setTaskData(result.data.task_data);
          initialDataRef.current = result.data.task_data;
        }

        // материалы задания
        if (result.data.form.asset_set) {
          setAssetSet(result.data.form.asset_set);
        }
        
        setLoading(false);
      },
      (error) => {
        console.log(error);
        setLoading(false);
      }
    );


  }, []);


  // Отслеживание изменений в форме
  /*
  function handleFormChange ({ data, errors }) {
    setTaskData(data);
    setErrors(errors); 

    const isFormDirty = JSON.stringify(data) !== JSON.stringify(initialDataRef.current);
    setIsDirty(isFormDirty);
  };
  */


  function handleFormChange ({ data, errors }) {
    setTaskData(data);
    setErrors(errors); 

    const isFormDirty = JSON.stringify(data) !== JSON.stringify(initialDataRef.current);
    setIsDirty(isFormDirty);
  };


  // кнопка "Проверить" - включить отображение ошибок заполнения формы
  function showFormValidation () {
    setValidationMode("ValidateAndShow")  
    window.scrollTo({
      top: 0,
      left: 0,
    })
  }; 

  // Сохранение результатов заполнения формы
  function saveTaskData () {
    let params = {'operation': 'update-task-data', 'task_data': taskData};
    //console.log(params)

    axios_api.put(api_url + taskUrl + taskId, params, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        //console.log("Form data uploaded");
        setIsDirty(false)
        //navigate(taskAfterSubmitUrl);
        //navigate(0);
      },
      (error) => {
        console.log(error);
      }
    );
  }


  // Сохранение результатов заполнения формы и отправка результатов на проверку в ЕАС
  function submitTask () {
    let params = {'operation': 'submit-task-for-check', 'task_data': taskData};
    //console.log(params)
    
    axios_api.put(api_url + taskUrl + taskId, params, {
      headers: {
        "Authorization": token, 
        //"Content-Type": "application/json",
      }
    })
    .then(
      (result) => {
        //console.log("Form data uploaded");
        setIsDirty(false);
        allowNavigationAfterSubmitRef.current = true;
        
        // Выполняем навигацию после успешной отправки
        navigate(0);
        
        //window.scrollTo({top: 0, left: 0});
        //let newTaskParams = JSON.parse(JSON.stringify(taskParams));
        //newTaskParams.status = "SENT";
        //console.log(taskParams)
        //console.log(newTaskParams)
        //setTaskParams(newTaskParams);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  // блокировка закрытия окна при несохраненных данных
  React.useEffect(() => {
    const handleBeforeUnload = (event) => {
      // Не показывать предупреждение, если навигация происходит после успешного submitTask
      if (allowNavigationAfterSubmitRef.current) {
        return;
      }
      
      if (isDirty) {
        event.preventDefault();
        event.returnValue = ''; // Современный способ показать предупреждение
        return 'У вас есть несохранённые изменения. Уверены, что хотите уйти?';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);

  }, [isDirty]);


  let sentStatus = !(['AVAILABLE', 'IN_PROGRESS', 'OUTDATED', 'RETURNED'  ].includes(taskParams.status))
  let readonly = formMode === "lab" &&  sentStatus === true ? true : false 
  let statusDisplay = GetTaskStatus(taskParams.status);


  return loading ? 
    (
      <Loader/>
    ) : (
      <>
        <div className="row mt-3 me-3 mb-3" style={{ marginLeft: '30px'}}>
          <h3 className="ps-0">{taskParams.form?.name}</h3>
        </div>


        { formMode == "lab" &&       
          <FormHeaderLab
            taskParams={taskParams}
          />
        }

        { formMode == "specialist" &&    
          <FormHeaderSpecialist
            taskId={taskId}
            taskParams={taskParams}
            statusDisplay={statusDisplay}
          />
        }

        <ConfirmationModal
          modalId="confirmSendDataModal"
          headerText="Результаты исследований"
          messageText={[
            "Вы уверены, что хотите отправить данные на проверку?"
          ]}
          confirmButtonText="Отправить данные" 
          Action={() => submitTask()}
        />

        <div className="row mt-3 me-3 mb-3" style={{ marginLeft: '28px'}}>
          <div className='col-9 ps-0'>
            <div className="form-head p-3">
              <h6 
                style={{ cursor: 'pointer', display: 'flex'}}
                onClick={() => setIsMaterialsOpen(!isMaterialsOpen)}
              >
                Материалы к заданию
                <span className='ms-3'>{isMaterialsOpen ? '▼' : '▶'}</span>
              </h6>
              {isMaterialsOpen && assetSet.length > 0 && (
                <div className="mt-3">
                  <ul className="list-group">
                    {assetSet.map((asset, index) => (
                      <li key={index} className="list-group-item">
                        <a 
                          href={asset.file || asset.link} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                        >
                          {asset.name}
                        </a>
                        {asset.description && (
                          <div className="text-muted small mt-1">{asset.description}</div>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {isMaterialsOpen && assetSet.length === 0 && (
                <div className="mt-3 text-muted">
                  Материалы к заданию отсутствуют
                </div>
              )}
            </div>
          </div>  
        </div>   

        { validationMode == "ValidateAndShow" ?
          <div className="row mt-3 me-3 mb-3" style={{ marginLeft: '28px'}}>
            <div className='col-9 ps-0'>
              <div className="form-head p-3">
                {errors.length > 0 ?
                  <h6 className='text-danger'><b>Пожалуйста исправьте ошибки ниже. Число полей с ошибками - {errors.length}</b></h6>
                :
                  <h6 className='text-success'><b>Форма заполнена корректно. Ее можно отправить на проверку.</b></h6>
                }
              </div>
            </div>  
          </div>        
        :
          <></>
        }

        <div className='me-5' style={{ marginLeft: '28px'}}>
          <FormRenderer
            schema={taskParams.form?.form_schema}
            uiSchema={uiSchema}
            validationMode={validationMode}
            formViewMode={formViewMode}

            samplesDict={samplesDict}
            taskData={taskData}
            handleFormChange={handleFormChange}

            readonly={readonly}
          />
        </div>

        <div className="d-grid gap-2 d-md-flex justify-content-md-start my-5 ms-4 ps-1">
          <button onClick={saveTaskData} className='btn lk-button me-2'>Сохранить</button>
          <button onClick={showFormValidation} className='btn lk-button me-2'>Проверить</button>
          { validationMode == "ValidateAndShow" && errors.length == 0 && sentStatus === false ?
            <button className='btn lk-button' data-bs-toggle="modal" data-bs-target="#confirmSendDataModal">Отправить форму</button>  
          :
            <button type="button" className="btn lk-button" disabled>Отправить форму</button>
          }
        </div>

      </>
    );

}